import { Type } from '@sinclair/typebox';
import { NullishType } from '../../standard-schema.js';
const BaseChangelogSchema = Type.Object({
    auditableId: Type.String(),
    userId: Type.String(),
    reason: NullishType(Type.String()),
});
const PrismaDatetime = Type.Date();
// When getting there should always be id and timestamp
export const ToChangelogSchema = Type.Intersect([
    Type.Object({
        id: Type.String(),
        timestamp: PrismaDatetime,
    }),
    BaseChangelogSchema,
]);
// When creating, id and timestamp should not be forced
export const FromChangelogSchema = Type.Intersect([
    Type.Object({
        id: Type.Optional(Type.String()),
        timestamp: Type.Optional(PrismaDatetime),
    }),
    BaseChangelogSchema,
]);
